const productSwiper = new Swiper(".product-swiper", {
	slidesPerView: 1,
	spaceBetween: 10,
	loop: true,
	navigation: {
		nextEl: ".product-next",
		prevEl: ".product-prev",
	},
	breakpoints: {
		640: {
			slidesPerView: 2,
			spaceBetween: 30
		},
		1024: {
			slidesPerView: 3,
			spaceBetween: 30
		},
		1300: {
			slidesPerView: 4,
			spaceBetween: 30
		}
	}
});

const listSwiper = document.querySelector(".product-swiper");
if (!listSwiper) return;

const swiper = listSwiper.swiper;
const buttons = document.querySelectorAll(".product-buttons button");
const slides = listSwiper.querySelectorAll(".swiper-slide");

buttons.forEach(btn => {
	btn.addEventListener("click", () => {
		const filter = btn.dataset.filter;

		buttons.forEach(b => b.classList.remove("btn-active"));
		btn.classList.add("btn-active");

		slides.forEach(slide => {
			const category = slide.querySelector(".product-card")?.dataset.category;
			slide.style.display =
				filter === "all" || category === filter ? "block" : "none";
		});

		swiper.update();
		swiper.slideTo(0);
	});
});